export default __webpack_public_path__ + "54b7c6dd0e94869b867dd5673f91717d.png";